import React, { Component } from "react";
import IconClear from "material-ui/svg-icons/content/clear";
import IconDone from "material-ui/svg-icons/action/done";
import { RaisedButton, Dialog } from "material-ui";
import { red500, blue500 } from "material-ui/styles/colors";

const styles = {
	actionBtn: {
		margin: "10px"
	}
};

class ConfirmDialog extends Component {
	constructor(props) {
		super(props);
		this.state = { showConfirm: false };

		this.onCancel = this.onCancel.bind(this);
		this.onTapAccept = this.onTapAccept.bind(this);
	}

	open(props) {
		this.setState({ ...props, showConfirm: true });

		//onDecline //onAccept //messageConfirm // title
	}

	close() {
		this.setState({ showConfirm: false });
	}

	onCancel() {
		if (this.state.onDecline) {
			this.setState({ showConfirm: false });
			this.state.onDecline();
		} else {
			this.setState({ showConfirm: false }); // Cancel x default
		}
	}

	onTapAccept() {
		if (this.state.onAccept) {
			if (this.state.requiredValidation) {
				const valid = this.state.onAccept();
				if (valid) {
					this.setState({ showConfirm: false });
				}
			} else {
				this.setState({ showConfirm: false });
				this.state.onAccept();
			}
		} else {
			this.setState({ showConfirm: false }); // Cancel x default
		}
	}

	render() {
		let actions = [
			<RaisedButton
				label="Aceptar"
				labelColor="#fff"
				backgroundColor={blue500}
				style={styles.actionBtn}
				icon={<IconDone />}
				onClick={this.onTapAccept}
			/>,
			<RaisedButton
				label="Cancelar"
				labelColor="#fff"
				backgroundColor={red500}
				style={styles.actionBtn}
				icon={<IconClear />}
				onClick={this.onCancel}
			/>
		];
		if (this.props.info) {
			actions = [
				<RaisedButton
					label="Aceptar"
					labelColor="#fff"
					backgroundColor={blue500}
					style={styles.actionBtn}
					icon={<IconDone />}
					onClick={this.onTapAccept}
				/>
			];
		}

		return (
			<Dialog
				title={this.state.title}
				actions={actions}
				modal={true}
				autoScrollBodyContent={true}
				open={this.state.showConfirm}
				onRequestClose={this.onCancel}
			>
				{this.props.children ? this.props.children : this.state.messageConfirm}
			</Dialog>
		);
	}
}

export default ConfirmDialog;



// WEBPACK FOOTER //
// ./src/components/ConfirmDialog/ConfirmDialog.js